import api from "./api";

/**
 * Person-level 2FA channel preferences (WhatsApp / SMS / e-mail).
 * USB keys use /v1/oauth/webauthn/credentials (WebAuthnCredential table).
 */

export async function fetchTwoFactorSettings() {
  const { data } = await api.get("/v1/ib/accounts/me/two-factor");
  return normalizeTwoFactorSettings(data);
}

export async function updateTwoFactorSettings(payload) {
  const body = {
    preferred_two_factor_channel: payload.preferredLogin || payload.preferred_two_factor_channel,
    selected_login_methods:
      payload.selectedLoginMethods || payload.selected_login_methods || [],
    google_authenticator_enabled:
      payload.googleAuthenticatorConfigured ??
      payload.google_authenticator_enabled,
  };

  const country = payload.countryDialCode ?? payload.country_dial_code;
  const area = payload.areaCode ?? payload.area_code;
  const local = payload.phoneLocalNumber ?? payload.phone_local_number;
  const phoneNumber = payload.phoneNumber ?? payload.phone_number;

  if (country || area || local || phoneNumber) {
    if (country) body.country_dial_code = String(country).replace(/\D/g, "");
    if (area) body.area_code = String(area).replace(/\D/g, "");
    if (local) body.phone_local_number = String(local).replace(/\D/g, "");
    if (phoneNumber) body.phone_number = String(phoneNumber).replace(/\D/g, "");
  }

  const { data } = await api.put("/v1/ib/accounts/me/two-factor", body);
  return normalizeTwoFactorSettings(data);
}

function normalizeTwoFactorSettings(data) {
  const selected = Array.isArray(data?.selected_login_methods)
    ? data.selected_login_methods.map((m) => String(m || "").toLowerCase())
    : Array.isArray(data?.selectedLoginMethods)
      ? data.selectedLoginMethods.map((m) => String(m || "").toLowerCase())
      : [];

  return {
    preferredLogin: String(
      data?.preferred_two_factor_channel ??
        data?.preferredTwoFactorChannel ??
        selected[0] ??
        "email"
    ).toLowerCase(),
    selectedLoginMethods: selected,
    googleAuthenticatorConfigured:
      data?.google_authenticator_enabled === true ||
      data?.googleAuthenticatorEnabled === true,
    whatsappNotification:
      data?.whatsapp_notification === true || data?.whatsAppNotification === true,
    smsAppNotification:
      data?.sms_app_notification !== false && data?.smsAppNotification !== false,
    emailAppNotification:
      data?.email_app_notification !== false && data?.emailAppNotification !== false,
    hasWebAuthn: data?.has_web_authn === true || data?.hasWebAuthn === true,
    phoneNumber: data?.phone_number ?? data?.phoneNumber ?? "",
    countryDialCode: data?.country_dial_code ?? data?.countryDialCode ?? "",
    areaCode: data?.area_code ?? data?.areaCode ?? "",
    phoneLocalNumber: data?.phone_local_number ?? data?.phoneLocalNumber ?? "",
  };
}
